import type {
  ReviewsAISummary,
  ReviewsTag,
  ReviewsTagDetails,
} from '@backmarket/http-api/src/api-specs-reviews/types/ai-summary'

import { AI_SUMMARY_TAGS_DISPLAY_LIMIT } from './aiSummary.constants'

const REVIEW_AI_TAGS_ALLOWLIST: readonly ReviewsTag[] = [
  'QUALITY',
  'CONDITION',
  'AUTHENTICITY',
  'PERFORMANCE',
  'BATTERY',
  'TOUCHSCREEN',
  'SCREEN',
  'VALUE_FOR_MONEY',
  'ACCESSORIES',
  'UNLOCKED_STATUS',
  'KEYBOARD',
]

const ALLOWED_REVIEW_AI_TAGS = new Set(REVIEW_AI_TAGS_ALLOWLIST)

function orderTagsBySentiment(tags: ReviewsTagDetails[]): ReviewsTagDetails[] {
  const positiveOrNeutral: ReviewsTagDetails[] = []
  const negative: ReviewsTagDetails[] = []

  for (const detail of tags) {
    if (detail.sentiment === 'negative') {
      negative.push(detail)
    } else {
      positiveOrNeutral.push(detail)
    }
  }

  return [...positiveOrNeutral, ...negative]
}

export function transformReviewsAISummary(
  data: ReviewsAISummary | null | undefined,
): ReviewsAISummary | null | undefined {
  if (data === null || data === undefined) return data

  const allowedTags = data.tags.filter((detail) =>
    ALLOWED_REVIEW_AI_TAGS.has(detail.tag),
  )

  const topByCount = allowedTags.slice(0, AI_SUMMARY_TAGS_DISPLAY_LIMIT)

  return {
    ...data,
    tags: orderTagsBySentiment(topByCount),
  }
}
